import AccountService from "../services/account.service";
import Util from "../utils/util";
import configureStore from "../store/configureStore";
const store = configureStore();

export const setGuestToken = (countryCode) => {
  return (dispatch, getState) => {
    AccountService.getGuestToken(countryCode)
      .then(data => {
        if (data && data.token && data.token.value) {
          dispatch({
            type: "SET_GUEST",
            token: data.token.value
          });
        }
      })
      .catch(e => {
        console.log(e);
        window.togglePreloader(true);
        window.location.href = "/error";
      });
  };
};
export const createAccount = request => {
  return (dispatch, getState) => {
    const store = getState();
    const guestToken =
      store && store.user && store.user.guestToken ? store.user.guestToken : "";
    const headers = {};
    headers["Authorization"] = guestToken;
    return AccountService.createAccount(request, headers)
      .then(data => {
        if (data && data.customer_id && data.token) {
          Util.clearLoggedInUserDetails();
          if (data.token && typeof data.token === "object") {
            Util.setSFCCToken(data.token.value, data.token.expiry, false);
          } else {
            Util.setSFCCToken(data.token, undefined, false);
          }
          Util.setLoggedInUserDetails(data);
        }
        return data;
      })
      .catch(e => {
        console.log(e);
        window.togglePreloader(true);
        window.location.href = "/error";
      });
  };
};

export const fetchAccount = customerId => {
  return (dispatch, getState) => {
    return AccountService.fetchAccount(customerId).then(data => {
      if (data && data.customer_id) {
        return data;
      } else {
        console.log("no data");
      }
    });
  };
};

export const updateAccount = (customerId, request) => {
  return (dispatch, getState) => {
    request.c_lastModifiedDate = new Date().toISOString();
    return AccountService.updateProfile(customerId, request)
      .then(data => {
        if (data && data.customer_id) {
          const currentUser = Util.getLoggedInUserDetails();
          const needRememberUser =
            Util.getStringFromStorage(Util.NEED_REMEMBER_USER) || "false";
          let updatedUser = { ...data, wishlistId: currentUser.wishlistId };
          Util.setLoggedInUserDetails(updatedUser, needRememberUser);
        }
        return data;
      })
      .catch(e => {
        console.log(e);
        window.togglePreloader(true);
        window.location.href = "/error";
      });
  };
};
export const login = (login, password, rememberMe) => {
  return (dispatch, getState) => {
    const storeDetails = Util.getStoreDetails();
    let loyaltyProgramDetails = {};
    try {
      loyaltyProgramDetails = JSON.parse(storeDetails.config.loyaltyProgramDetails) || {};    
    } catch (error) {
      console.log(error);
      loyaltyProgramDetails = {};
    }
    const request = {
      type: "credentials",
      countryCode:storeDetails.countryCode,
      fMSSiteId: storeDetails.fMSSiteId,
      storeId: storeDetails.storeId,
      loyaltyProgramDetails: loyaltyProgramDetails
    };
    if (!rememberMe || rememberMe.toString() == "false") {
      Util.removeStringFromStorage(Util.NEED_REMEMBER_USER);
    }
    const headers = {};
    headers["Authorization"] = Util.getLoginHeader(login, password);
    return AccountService.login(request, headers)
      .then(data => {
        if (data && data.customer_id && data.token) {
          if (data.token && typeof data.token === "object") {
            Util.setSFCCToken(data.token.value, data.token.expiry, rememberMe);
          } else {
            Util.setSFCCToken(data.token, undefined, rememberMe);
          }
          Util.setLoggedInUserDetails(data, rememberMe.toString());
        }
        return data;
      })
      .catch(e => {
        console.log(e);
        window.togglePreloader(true);
        window.location.href = "/error";
      });
  };
};

const setWishlistCountTask = (count, dispatch) => {
  if (dispatch) {
    dispatch({
      type: "SET_WISHLIST_COUNT",
      wishlistCount: count || 0
    });
  }
}

export const clearWishlist = (count) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CLEAR_WISHLIST'
    });
  }
}

export const setFullWishlist = (list) => {
  return (dispatch, getState) => {
    if (list) {
      dispatch({
        type: "SET_WISHLIST",
        wishlist: list
      });
    }
  }
}

export const setWishlistCount = (count) => {
  return (dispatch, getState) => {
    setWishlistCountTask(count, dispatch);
  }
}
const syncWithLocalWishlist = (remoteList) => {
  let localWishlist = Util.getLocalWishlist() || [];
  localWishlist = localWishlist.reverse();
  if (remoteList && remoteList.length) {
    remoteList.forEach((remoteItem, remoteIndex) => {
      localWishlist.forEach((localItem, localIndex) => {
        if (localItem.productId == remoteItem.productId) {
          localWishlist.splice(localIndex, 1);
        }
      });
    });
    return localWishlist.concat(remoteList);
  } else {
    return localWishlist;
  }
}
const syncWishlistWithServer = (customerId, wishlistId) => {
  // const listTobeSynced = Util.getNormalizedLocalWishlist(serverWishlistItems);
  const listTobeSynced = Util.getLocalWishlist();
  const storeDetail = Util.getStoreDetails();
  if (listTobeSynced && listTobeSynced.length) {
    const syncItemArray = [];
    listTobeSynced.forEach(item => {
      const reqObj = Util.getAddToWishlistRequest(item, wishlistId);
      if (reqObj) {
        syncItemArray.push(reqObj);
      }
    });
    const request = {
      "wishListId": wishlistId || '',
      "syncItemList": syncItemArray,
      "countryCode":storeDetail.countryCode
    };
    return AccountService.syncWishlist(customerId, request)
      .then((data) => {
        if (data && data.status == 'Success' && data.wishlistId) {
          const userDetails = Util.getLoggedInUserDetails();
          userDetails.wishlistId = data.wishlistId;
          Util.updateLoggedInUserDetails(userDetails);
        }
        if (data && data.status == 'Success' && data.syncedItems && data.syncedItems.length) {
          const localWishlistItems = Util.getLocalWishlist();
          const localWishlistItemsCopy = Util.getLocalWishlist();;
          if (localWishlistItems && localWishlistItems.length) {
            localWishlistItems.forEach((wishlistItem, index) => {
              if (wishlistItem && wishlistItem.productId && data.syncedItems.includes(wishlistItem.productId)) {
                let valueIndex = Util.getIndexFromAttrib(localWishlistItemsCopy, 'productId', wishlistItem.productId);
                localWishlistItemsCopy.splice(valueIndex, 1);
              }
            });
            Util.setLocalWishlist(localWishlistItemsCopy);
            // setWishlistCountTask((Number(serverWishlistCount)+localWishlistItems.length), dispatch);
          }
        }
        if (data && data.status == 'Success' && data.pendingItems && data.pendingItems.length) {
          Util.addObjectToSessionStorage(Util.WISHLIST_PENDING_SYNC_ITEMS, data.pendingItems);
        }
        return data;
      })
      .catch(error => {
        // setWishlistCountTask((Number(serverWishlistCount)), dispatch);
        console.log(error);
        return error;
      });
  } else {
    return new Promise((resolve, reject) => {
      resolve({});
    });
  }
}
const getWishlistTask = (customerId, wishlistId, request, start = 0, count = Util.WISHLIST_PAGE_COUNT, dispatch, resolve, reject) => {
  return AccountService.getWishlist(customerId, wishlistId, request, start, count)
    .then(data => {
      Util.clearCookie(Util.COOKIE_NAMES.PREVIOUS_PAGE);
        // TODO: ADD LOCAL WISHLIST ITEMS TO COMMON ITEM LIST
        const normalizedLocalItemCount = Number(Util.getNormalizedLocalWishlistCount(data.items));
        data.items = syncWithLocalWishlist(data.items);
        if (data && data.items && data.items.length) {
          setWishlistCountTask((Number(data.total)+normalizedLocalItemCount), dispatch);
          if (start > 0) {
            dispatch({
              type: "UPDATE_WISHLIST",
              wishlist: data.items
            });
          } else {
            Util.addObjectToSessionStorage(Util.LOADED_WISHLIST, data.items);
            dispatch({
              type: "SET_WISHLIST",
              wishlist: data.items
            });
          }
        } else {
          if (start <= 0) {
            dispatch({
              type: "SET_WISHLIST",
              wishlist: []
            });
            setWishlistCountTask((normalizedLocalItemCount || 0), dispatch);
          }
        }
        resolve(data);
    })
    .catch(e => {
      console.log(e);
      window.togglePreloader(true);
      window.location.href = "/error";
    });
}
export const getWishlist = (customerId, wishlistId, request, start = 0, count = Util.WISHLIST_PAGE_COUNT) => {
  return (dispatch, getState) => {
    const storeDetail= Util.getStoreDetails();
    if (request) {
      request.isLoggedIn = (Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN ? "true": "false");
      request.countryCode = storeDetail.countryCode;

    }
    if (customerId && wishlistId) {
      // TODO: Sync Wishlist
      return new Promise((resolve, reject) => {
        syncWishlistWithServer(customerId, wishlistId)
          .then(data => {
            getWishlistTask(customerId, wishlistId, request, start = 0, count = Util.WISHLIST_PAGE_COUNT, dispatch, resolve, reject);
          })
          .catch(error => {
            getWishlistTask(customerId, wishlistId, request, start = 0, count = Util.WISHLIST_PAGE_COUNT, dispatch, resolve, reject);
          });
      })
      
    } else if (customerId && !wishlistId) {
      // TODO: Sync Wishlist
      return new Promise((resolve, reject) => {
        syncWishlistWithServer(customerId, '')
          .then(data => {
            if (data && data.status == 'Success' && data.syncedItems && data.syncedItems.length) {
              getWishlistTask(customerId, data.wishlistId, request, start = 0, count = Util.WISHLIST_PAGE_COUNT, dispatch, resolve, reject);
            } else {
                let localWishlist = Util.getLocalWishlist() || [];
                localWishlist = localWishlist.reverse();
                Util.addObjectToSessionStorage(Util.LOADED_WISHLIST, localWishlist);
                setWishlistCountTask(localWishlist.length, dispatch);
                dispatch({
                  type: "SET_WISHLIST",
                  wishlist: localWishlist
                });
                resolve({items: localWishlist});
            }
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        let localWishlist = Util.getLocalWishlist() || [];
        localWishlist = localWishlist.reverse();
        Util.addObjectToSessionStorage(Util.LOADED_WISHLIST, localWishlist);
        setWishlistCountTask(localWishlist.length, dispatch);
        dispatch({
          type: "SET_WISHLIST",
          wishlist: localWishlist
        });
        resolve({items: localWishlist});
      });  
    }
  };
};

export const removeFromWishlist = (customerId, wishlistId, itemId, countryCode) => {
  return (dispatch, getState) => {
    return AccountService.removeFromWishlist(customerId, wishlistId, itemId, countryCode)
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(e);
        window.togglePreloader(true);
        window.location.href = "/error";
      });
  };
};

export const addProductToWishlist = (customerId, request) => {
  return (dispatch, getState) => {
    return AccountService.addProductToWishlist(customerId, request)
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(e);
        window.togglePreloader(true);
        window.location.href = "/error";
      });
  };
};

export const updatePassword = (customerId, request) => {
  return (dispatch, getState) => {
    return AccountService.updatePassword(customerId, request)
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(e);
        window.togglePreloader(true);
        window.location.href = "/error";
      });
  };
};

export const invalidateToken = (countryCode) => {
  return (dispatch, getState) => {
    return AccountService.invalidateToken(countryCode)
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(e);
        window.togglePreloader(true);
        window.location.href = "/error";
      });
  };
};

export const getPersonalizedPromos = () => {
  return (dispatch, getState) => {
    if (Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN) {
      const personalizedPromosList = Util.getObjectFromSessionStorage(Util.PERSONALIZED_PROMO_LIST) || [];
      if (!personalizedPromosList || !personalizedPromosList.length || personalizedPromosList.length <= 0) {
        const userDetail = Util.getLoggedInUserDetails();
        const storeDetail = Util.getStoreDetails();
        let loyaltyProgramDetails = {};
        if (storeDetail && storeDetail.config && storeDetail.config.loyaltyProgramDetails) {
          try {
            loyaltyProgramDetails = JSON.parse(storeDetail.config.loyaltyProgramDetails) || {};    
          } catch (error) {
            console.log(error);
            loyaltyProgramDetails = {};
          }
        }
        const request = {
          storeId: storeDetail.storeId,
          jwtToken: userDetail.jwtToken,
          loyaltyProgramDetails: loyaltyProgramDetails,
          membershipId: userDetail.c_membershipID || '',
          additionalCustomerInfoRequired:true
        };
        if (userDetail && userDetail.birthday) {
          let userBirthday = userDetail.birthday;
          userBirthday = userBirthday.split('-');
          if (userBirthday[1] && userBirthday[2]) {
            userBirthday = userBirthday[1] + '-' + userBirthday[2]; // taking only month and day, omitting year
            request.birthday = userBirthday;
          }
        }
        return AccountService.getPersonalizedPromos(request)
        .then(data => {
          if(data && data.allPerksDetail && data.allPerksDetail.additionalCustomerInfo)
          {
            Util.addObjectToSessionStorage(Util.USER_CUSTOM_ATTRIBUTE, data.allPerksDetail.additionalCustomerInfo )
            dataLayer.push({
              event: "dataLayer-initialized",
              customAttributes:Util.getCustomAttributes(),
              userID: Util.getEmailId(),
              language: Util.getSelectedLanguage(),
              pageName: window.location.pathname,
              pageType: window.location.pathname,
              storeID: Util.getStoreDetails().storeId,
              storeDesc: Util.getStoreDetails().name,
              flowConfig: Util.getGAFlowConfig(),
              signedIn: (Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN) ? 'signed-in user' : 'guest'
            });
        
          }
          let datalabCustomerId;
          if (data && data.customer_id) {
            datalabCustomerId = data.customer_id;
          } else {
            datalabCustomerId = '';
          }
          Util.addStringToStorage(Util.DATALAB_CUSTOMER_ID, datalabCustomerId);
          if (data && data.personalizedPromosList) {
            Util.addObjectToSessionStorage(Util.PERSONALIZED_PROMO_LIST, data.personalizedPromosList);
            Util.addObjectToSessionStorage(Util.PERK_LIST, (data.allPerksDetail && data.allPerksDetail.perk ? data.allPerksDetail.perk : []));
          }
          return data;
        })
        .catch(e => {
          console.log(e);
          window.togglePreloader(true);
          window.location.href = "/error";
        });
      } else {
        return new Promise((resolve, reject) => {
            dataLayer.push({
              event: "dataLayer-initialized",
              customAttributes:Util.getCustomAttributes(),
              userID: Util.getEmailId(),
              language: Util.getSelectedLanguage(),
              pageName: window.location.pathname,
              pageType: window.location.pathname,
              storeID: Util.getStoreDetails().storeId,
              storeDesc: Util.getStoreDetails().name,
              flowConfig: Util.getGAFlowConfig(),
              signedIn: (Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN) ? 'signed-in user' : 'guest'
            });
          resolve({personalizedPromosList: personalizedPromosList});
        });  
      }
    } else {
      return new Promise((resolve, reject) => {
        dataLayer.push({
          event: "dataLayer-initialized",
          customAttributes:Util.getCustomAttributes(),
          userID: Util.getEmailId(),
          language: Util.getSelectedLanguage(),
          pageName: window.location.pathname,
          pageType: window.location.pathname,
          storeID: Util.getStoreDetails().storeId,
          storeDesc: Util.getStoreDetails().name,
          flowConfig: Util.getGAFlowConfig(),
          signedIn: (Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN) ? 'signed-in user' : 'guest'
        });
        resolve({
          personalizedPromosList: [],
          customer_id: Util.getStringFromStorage(Util.DATALAB_CUSTOMER_ID) || ''
        });
      });
    }
  };
};

export const triggerWelcomeEmail = (request) => {
  return (dispatch, getState) => {
    return AccountService.triggerWelcomeEmail(request)
    .then(data => {
      return data;
    });
  }
}
